import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/visiteurs` used to be the Invitations page; it now hosts nothing.
 *  Old bookmarks land on Invitations. The visitors directory is `/repertoire`. */
export const Route = createFileRoute("/_dashboard/visiteurs")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/invitations", replace: true });
  },
});
